import script from "./pc-module-cross-analysis-6.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-cross-analysis-6.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-cross-analysis-6.vue?vue&type=style&index=0&id=8d6133b8&lang=scss"

const __exports__ = script;

export default __exports__